import { useUiPreferences } from '../useUiPreferences';
import { Section, SegmentedRow } from '../SettingsRows';

// InterfaceTab owns server-wide browsing defaults. 'ui.pagination.per_page'
// is the default page size the library browse pages (artists, albums, ...)
// use when their URL has no explicit per_page - the server's pagination
// helper reads the same key for its default (50 when nothing is stored).
const DEFAULTS = { 'ui.pagination.per_page': '50' };

const PER_PAGE_OPTIONS = ['25', '50', '100', '250'];

export function InterfaceTab(): React.JSX.Element {
    const [prefs, save] = useUiPreferences(DEFAULTS);

    return (
        <>
            <Section title="Browsing">
                <SegmentedRow
                    label="Items per page"
                    desc="Default page size for the artists and albums lists."
                    options={PER_PAGE_OPTIONS}
                    value={prefs['ui.pagination.per_page']}
                    onChange={(v) => save({ 'ui.pagination.per_page': v })}
                />
            </Section>
        </>
    );
}
